module.exports = __webpack_public_path__ + "static/media/poster-88.6c4f21be.png";